export default "__VITE_ASSET__CkkysZES__"